import { JSX } from "react";

import { STACK_PULL_REQUESTS_COLUMN_ID } from "../../constants";
import { StackPullRequestsTableRunCellProps } from "../types";
import StackPullRequestsTableRunDeltaCell from "./DeltaCell";
import StackPullRequestsTableRunEmptyCell from "./EmptyCell";
import StackPullRequestsTableRunOpenedAtCell from "./OpenedAtCell";
import StackPullRequestsTableRunStatusCell from "./StatusCell";
import StackPullRequestsTableRunTitleCell from "./TitleCell";

export const STACK_PULL_REQUESTS_RUN_CELLS: Record<
  string,
  (props: StackPullRequestsTableRunCellProps) => JSX.Element
> = {
  [STACK_PULL_REQUESTS_COLUMN_ID.STATUS]: StackPullRequestsTableRunStatusCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.TITLE]: StackPullRequestsTableRunTitleCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.AUTHOR]: StackPullRequestsTableRunEmptyCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.PR]: StackPullRequestsTableRunEmptyCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.BRANCH]: StackPullRequestsTableRunEmptyCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.DELTA]: StackPullRequestsTableRunDeltaCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.CREATED_AT]: StackPullRequestsTableRunOpenedAtCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.ROW_ACTIONS]: StackPullRequestsTableRunEmptyCell,
};
